export const WriteRight = "WEB_MODULE_PILOT_COURSE_WRITE";
export const ReadRight = "WEB_MODULE_PILOT_COURSE_READ";

export const Rights = [
    WriteRight,
    ReadRight
]
